import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ImmigrationWizardService } from 'src/app/modules/immigration-wizard/services/immigration-wizard.service';

@Component({
  selector: 'app-switch-mode-popup',
  templateUrl: './switch-mode-popup.component.html',
  styleUrls: ['./switch-mode-popup.component.scss']
})
export class SwithModePopupComponent implements OnInit {

  selectedCategory: any = null;
  categoriesTypes: any[] = [
    { name: 'Upload documents and generate information(System Default)', key: "upload" },
    { name: 'Add manually on behalf of individuals', key: "individual" },
    { name: 'Send request to the individual requesting for Data & Documents', key: "individualDetailsType" }
  ];

  categories = [
    { name: 'Itinerary of Services', key: "itinerary"},
    { name: 'Beneficiary Qualifications', key: "qualification"},
    { name: 'Enter Employer Employee Relationship Details', key: "eer"}
  ];
  selectedCategories: any = [];
  isrequestDataDocument: boolean = false;
  isVisible: boolean = true;
  superTaskId: any;

  constructor(
    public dialogService: DialogService,
    public immigrationWizardService: ImmigrationWizardService,
    private wizardDialogRef: DynamicDialogRef,
    private toastr: ToastrService,
  ) {
    this.selectedCategory = this.categoriesTypes[1];
    // this.selectedCategories.push(this.categories[1]);
  }

  ngOnInit(): void {
    this.immigrationWizardService.getWizardTaskDetails$().subscribe((res: any) => {
      if(res){
        this.superTaskId =  res.superTaskId;
      }
    });
    this.immigrationWizardService.getWizardSettingsDetails$().subscribe((res: any) => {
      if(res){
        Object.keys(res).forEach(key=> {
          const val = res[key];
          switch(key) {
              case 'individualDetailsType': 
                    if(val=="REQTINDIVIDUALDOC"){
                      this.isrequestDataDocument = true;
                    }
                    break;
              case 'eerDetails': 
                    if(val==1){
                      this.selectedCategories.push(this.categories[2]);
                    }
                    break;
              case 'ios': 
                    if(val==1){
                      this.selectedCategories.push(this.categories[0]);
                    }
                    break;
              case 'qualification': 
                    if(val==1){
                      this.selectedCategories.push(this.categories[1]);
                    }
                    break;
              case 'default':
                    break;
          }
        });
        this.isVisible = true;
      }
    })
  }
  
  checkValue(event){
    console.log(event);
  }

  closePopup(data) {
    this.wizardDialogRef.close(data);
  }

  onChangeOption(event){
    this.isrequestDataDocument = event;
  }

  onSubmit(){
    const payload = {
      eerDetails: this.selectedCategories.find(x=>x.key=="eer") ? 1 : 0,
      individualDetailsType: this.isrequestDataDocument ? "REQTINDIVIDUALDOC" : null,
      ios: this.selectedCategories.find(x=>x.key=="itinerary") ? 1 : 0,
      qualification: this.selectedCategories.find(x=>x.key=="qualification") ? 1 : 0,
    };
    this.immigrationWizardService.saveWizardSettings(this.superTaskId, payload).subscribe(res=>{
      if(res){
        this.toastr.success(res.message, 'Success');
        //this.closePopup(true);
        this.closePopup({saved: true, data:payload, cancel: false });
      }
    });
  }
}
